import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import axios from 'axios'
import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import actionTypes from '../../action-types'
import fetchImporterDryRun from '../../actions/importers/dryRunImporter'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onFetchImporterDryRun = function* onFetchImporterDryRun() {
  yield takeLatest(actionTypes.IMPORTERS.DRY_RUN, function* onFetchImporterDryRunSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    let response
    const { payload } = action

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.importers}/${payload}/dry-run`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
          'X-Infowijs-Client': 'nl.infowijs.admin',
        },
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reFetchImporterDryRun() {
          yield put(fetchImporterDryRun(payload))
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    acceptAction(action, response.data.data || [])
  })
}

export default onFetchImporterDryRun
